import { ButtonFlavor, ButtonSize, ButtonType, ExButton } from '@boomi/exosphere';
import type { ReactElement } from 'react';
import { translations } from '../translations/translations';
import { useApp } from './AppProvider';

import './confirm-action.css';

interface Props {
    messages: ReactElement[] | string[];
    onConfirm: () => void;
    onCancel: () => void;
    testId?: string;
}

const ConfirmAction = ({ messages, onConfirm, onCancel, testId = 'confirmActionPanel' }: Props) => {
    const { language } = useApp();

    return (
        <div className="confirm-action-panel" data-testid={testId}>
            <div className="action-message data md">{messages}</div>
            <ExButton
                data-testId="confirmDeleteButton"
                className="action-confirm exo-button"
                flavor={ButtonFlavor.RISKY}
                size={ButtonSize.LARGE}
                type={ButtonType.PRIMARY}
                onClick={onConfirm}
            >
                {translations[language].COMMON_delete}
            </ExButton>
            <ExButton
                data-testId="confirmCancelButton"
                className="action-cancel exo-button"
                flavor={ButtonFlavor.BASE}
                size={ButtonSize.LARGE}
                type={ButtonType.SECONDARY}
                onClick={onCancel}
            >
                {translations[language].COMMON_cancel}
            </ExButton>
        </div>
    );
};

export default ConfirmAction;
